import { css } from 'emotion';

import { colors, icons } from '@cobliteam/base-components/src/styles';

export const checklistReceivedItemWrapper = css`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
`;

export const descriptionWrapper = css`
  display: flex;
  width: 100%;
`;

export const checklistIcon = css`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 26px;
  width: 26px;
  background-color: ${colors.gray.lightest};
  color: ${colors.gray.dark};
  border-radius: 3px;
  margin-right: 20px;
  flex-shrink: 0;

  svg {
    width: ${icons.size.small};
    height: ${icons.size.small};
  }
`;

export const wrapper = css`
  display: flex;
  flex-direction: column;
  width: 100%;
  top: 4px;
  position: relative;
`;

export const descriptionAndDetails = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const requiredText = css`
  margin-left: 20px;
  display: flex;
  align-items: center;
`;

export const titleItem = css`
  margin-top: 20px;
`;
